export function markInitialised(element, key = 'jsInitialised') {
	if (!element || !element.dataset) return false

	if (element.dataset[key] === 'true') return false

	element.dataset[key] = 'true'
	return true
}

export function setExpanded(element, isExpanded) {
	if (!element) return

	element.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
}

export function isActivationKey(event) {
	return event.key === 'Enter' || event.key === ' '
}

export function destroySwiper(container) {
	if (!container || !container.swiper) return

	container.swiper.destroy(true, true)
}
